import React from "react";
import { FaArrowRightLong, FaArrowTrendUp } from "react-icons/fa6";
import { MdWaterDrop } from "react-icons/md";
// import { Popup } from "semantic-ui-react";
import CustomInputSeparate from "../../all-patient/components/CuInputSeprate";
import VitalView from "../../new_consultation/component/VitalView";
import { CustomDropdown } from "../../new_consultation/views/ConsultationVitals";
import Popup from "../../common_component/component/Popup";

const Vitals = ({ vitals, setVitals }) => {
  const getUnitOptions = (units) => {
    return units.split(",").map((unit) => ({ value: unit, text: unit }));
  };

  const unitChangeHandler = (selectedUnit, vitalId) => {
    setVitals((prev) => {
      return prev.map((vital) =>
        vital.id === vitalId ? { ...vital, selected_unit: selectedUnit } : vital
      );
    });
  };

  const onVitalChange = (value, id) => {
    setVitals((prev) =>
      prev.map((vital) =>
        vital.id === id
          ? {
              ...vital,
              value1: value.split("/")[0],
              value2: value.split("/")[1],
            }
          : vital
      )
    );
  };

  return (
    <div className="flex flex-wrap gap-5 mt-[90px] justify-center">
      {vitals?.map((vital) => (
        <div className="w-[90%]" key={vital?.id}>
          <div className="flex items-center">
            <label className="">{vital?.type?.label}</label>
            {vital?.type?.label.toLowerCase() !== "spo2" &&
              vital?.type?.label.toLowerCase() !== "height" && (
                <Popup
                  trigger={
                    (vital?.type?.label.toLowerCase() === "bp" && (
                      <FaArrowTrendUp
                        size={12}
                        className="cursor-pointer text-red-500 ml-3"
                      />
                    )) ||
                    (vital?.type?.label.toLowerCase() === "weight" && (
                      <FaArrowTrendUp
                        size={12}
                        className="cursor-pointer text-green-500 ml-3"
                      />
                    )) ||
                    (vital?.type?.label.toLowerCase() === "pulse" && (
                      <FaArrowRightLong
                        size={12}
                        className="cursor-pointer text-yellow-500 ml-3"
                      />
                    )) ||
                    (vital?.type?.label.toLowerCase() === "temprature" && (
                      <FaArrowRightLong
                        size={12}
                        className="cursor-pointer text-red-500 ml-3"
                      />
                    ))
                  }
                  content={
                    <VitalView
                      label={vital?.type?.label}
                      // previousVisits={previousVisits}
                    />
                  }
                  position="right"
                />
              )}
          </div>
          <div className="cu-mobile-consultation-vital-field">
            <CustomInputSeparate
              separator="/"
              maxLength={3}
              fieldCount={vital?.type?.label.toLowerCase() === "bp" ? 2 : 1}
              initialValues={[
                vital?.value1 === 0 ? "" : vital?.value1,
                vital?.value2 === 0 ? "" : vital?.value2,
              ]}
              inputWidth={`100%`}
              // className={`h-[45px]`}
              onChange={(value) => onVitalChange(value, vital?.id)}
              unit={vital?.selected_unit}
              label={vital?.type?.label}
            />

            <CustomDropdown
              options={getUnitOptions(vital?.type?.unit)}
              value={vital.selected_unit}
              onChange={(selectedUnit) =>
                unitChangeHandler(selectedUnit, vital?.id)
              }
            />
          </div>
        </div>
      ))}
      {/* <div className="flex gap-3 items-center w-[45%]">
        <MdWaterDrop color="black" />
        <span className="text-[#404040] text-sx">96%</span>
      </div>
      <div className="flex gap-3 items-center w-[45%]">
        <MdWaterDrop color="black" />
        <span className="text-[#404040] text-sx">96%</span>
      </div>
      <div className="flex gap-3 items-center w-[45%]">
        <MdWaterDrop color="black" />
        <span className="text-[#404040] text-sx">96%</span>
      </div>
      <div className="flex gap-3 items-center w-[45%]">
        <MdWaterDrop color="black" />
        <span className="text-[#404040] text-sx">96%</span>
      </div> */}
    </div>
  );
};

export default Vitals;
